export default "__VITE_ASSET__25cf1540__"